<template>
  <div>
    <div class="filter-wrap">
      <v-select
        v-model="currentOperFilter"
        class="filter"
        label="Операции"
        color="secondary"
        :items="dropdownOperItems"
        item-title="title"
      >
        <template #selection="{ item }">
          {{ item.title }}
        </template>

        <template #item="{ item }">
          {{ item.title }}
        </template>
      </v-select>
      <v-spacer />

      <v-select
        v-model="currentStatusFilter"
        class="filter"
        label="Статусы"
        color="secondary"
        :items="dropdownStatusItems"
        item-title="title"
      >
        <template #selection="{ item }">
          {{ item.title }}
        </template>

        <template #item="{ item }">
          {{ item.title }}
        </template>
      </v-select>
      <v-spacer />

      <v-text-field
        v-model="outerTransactionId"
        class="filter"
        append-icon="search"
        color="accent"
        label="Внешний id операции"
        single-line
        hide-details
      />

      <v-text-field
        v-model="paymentTransactionId"
        class="filter"
        append-icon="search"
        color="accent"
        label="Id операции"
        single-line
        hide-details
      />
    </div>
    <paginated-table
      ref="paginatedTable"
      :items="items"
      :headers="headers"
      :search="search"
      :loading="loading"
      custom-class="user-table"
      :pullFunction="pullFunction"
      :pagination.sync="pagination"
    >
      <template #items="props">
        <UserTransactionsItem :item="props.item" @copied="wasCopied = true" />
      </template>
    </paginated-table>
    <v-snackbar v-model="wasCopied" color="green">
      <p style="margin: 0 auto">Скопировано!</p>
    </v-snackbar>
  </div>
</template>

<script>
import UserTransactionsItem from './UserTransactionsItem'
import { getTransactions } from '../../../../../api/transactions'
import PaginatedTable from '@/components/PaginatedTable.vue'

export default {
  name: 'UserTransactionsTable',
  components: { PaginatedTable, UserTransactionsItem },
  data () {
    return {
      search: '',
      outerTransactionId: '',
      paymentTransactionId: '',
      page: 1,
      pagination: {
        sortBy: 'created_at',
        descending: true
      },
      loading: true,
      wasCopied: false,
      SELECTED_ITEM_STATUS: {
        0: 'В обработке',
        1: 'Отказано',
        2: 'Принято',
        4: 'Запрос отправлен',
        9: 'На бэке',
        10: 'В обработке'
      },
      currentOperFilter: null,
      dropdownOperItems: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'Вывод',
          value: 'Вывод'
        },
        {
          title: 'Пополнение',
          value: 'Пополнение'
        }
      ],
      currentStatusFilter: null,
      dropdownStatusItems: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'В обработке',
          value: 0
        },
        {
          title: 'Отказано',
          value: 1
        },
        {
          title: 'Принято',
          value: 2
        },
        {
          title: 'Запрос отправлен',
          value: 4
        },
        {
          title: 'На бэке',
          value: 9
        }
      ],
      headers: [
        { text: 'Дата и время', value: 'created_at' },
        { text: 'Тип операции', value: 'operation' },
        { text: 'Метод', value: 'method' },
        { text: 'Платежная система', value: 'payway' },
        { text: 'ID операции', value: 'payment_transaction_id' },
        { text: 'Внешний ID операции', value: 'outer_transaction_id' },
        { text: 'Статус', value: 'status' },
        { text: 'Номер карты/кошелька', value: 'bill' },
        { text: 'Банк', value: 'bank_name' },
        { text: 'Сумма', value: 'amount' },
        { text: 'Апелляция', value: 'appeals' }
      ],
      items: []
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    currentStatusFilter () {
      this.pullFunction(1)
    },
    currentOperFilter () {
      this.pullFunction(1)
    },
    outerTransactionId () {
      this.pullFunction(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    paymentTransactionId () {
      this.pullFunction(1)
      this.$refs.paginatedTable?.resetPagination()
    }
  },
  created () {
    this.pullFunction(1)
  },
  mounted () {
    EventBus.$on('update-user-transaction-table', () => this.pullFunction(1))
  },
  beforeDestroy () {
    EventBus.$off('update-user-transaction-table')
  },
  methods: {
    pullFunction (page) {
      this.page = page
      getTransactions({
        limit: 26,
        offset: (page - 1) * 25,
        user_id: this.$route.params.user,
        sort: 'created_at:desc',
        outer_transaction_id: this.outerTransactionId,
        payment_transaction_id: this.paymentTransactionId,
        status: this.currentStatusFilter == 0 ? null : this.currentStatusFilter,
        statuses: this.currentStatusFilter == 0 ? [0, 10] : null,
        operation: this.currentOperFilter,
        with_appeals: 1
      }).then(response => {
        this.items = response.data
        this.items.forEach(item => {
          item.statusString = this.SELECTED_ITEM_STATUS[item.status]
        })
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.filter-wrap {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  p {
    margin: 0;
  }
  .filter {
    width: 30%;
  }
}
</style>
